<template>
  <div class="person">
    <div class="person_left">
      <ul class="person_left_title">
        <li class="title_top"><span>我的中心</span></li>
        <li
          v-for="(item,index) in leftTabs"
          :key="index"
          @click="toggleTabs(index,1)"
          :class="{current:index == leftTabsNowIndex}"
        >
          <img src="@/assets/images/goto.png"><a href="javascript:void(0);"> {{ item }}</a>
        </li>
      </ul>
    </div>
    <div class="person_right">
      <div class="person_right_top"><span>我的中心</span> - {{ leftTabs[leftTabsNowIndex] }}</div>
      <div class="person_right_content">
        <!-- 我的资料 -->
        <div
          class="person_info"
          v-show="leftTabsNowIndex === 0"
        >
          <ul>
            <li>
              <span class="lefttitle">头像：</span>
              <!-- <img :src="customerDatas.headimg"> -->
              <span class="customerDatasHeadimg">
                <img :src="customerDatas.headimg">
              </span>
            </li>
            <!-- <li><span class="lefttitle">拍卖号：</span><span>F2222</span><span class="explain">（竞拍编号，请牢记～）</span></li> -->
            <li><span class="lefttitle">用户名：</span><span>{{ customerDatas.nick_name }}</span><span class="explain"></span></li>
            <li>
              <span class="lefttitle">姓名：</span>
              <span>{{ customerDatas.name }}</span>
              <span
                class="state"
                v-if="customerDatas.enterprise_status == 1"
              >认证已通过</span>
              <span
                class="state"
                v-if="customerDatas.enterprise_status == 3"
              >您还未认证</span>
              <!-- <span
                class="state"
                v-if="customerDatas.real_status == 0"
              >认证失败，原因： {{ customerDatas.remark }}</span>
              <span
                class="state"
                v-if="customerDatas.enterprise_status == 2"
              >审核中</span> -->
              <span class="explain">（实名认证通过后，才可对标的进行报名参拍）</span>
            </li>
            <li><span class="lefttitle">手机号：</span><span>{{ customerDatas.phone }}</span><span class="explain">（手机号可作为登录账号，请牢记～）</span></li>
          </ul>
        </div>
        <!-- 实名认证 -->
        <div v-show="leftTabsNowIndex === 1">
          <Autonym></Autonym>
        </div>
        <!-- 我的竞拍 -->
        <div class="list_center" v-show="leftTabsNowIndex === 2">
          <Auction></Auction>
        </div>
        <!-- 我的收藏 -->
        <div class="order_center" v-show="leftTabsNowIndex === 3">
					<Orders></Orders>
				</div>
        <!-- 机构中心 跳转机构认证 -->
        <div v-show="leftTabsNowIndex === 4">
          <OrganizationCenter></OrganizationCenter>
        </div>
        <!-- 机构发布的标的 -->
        <div class="organization_center" v-show="leftTabsNowIndex === 5">
          <OrganizationBiaodi></OrganizationBiaodi>
        </div>
        <!-- 修改密码 -->
        <div v-show="leftTabsNowIndex === 6">
          <Repass></Repass>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auction from '@/components/Person/Auction.vue'
import Autonym from '@/components/Person/Autonym.vue'
import Orders from '@/components/Person/Orders.vue'
import OrganizationBiaodi from '@/components/Person/OrganizationBiaodi.vue'
import OrganizationCenter from '@/components/Person/OrganizationCenter.vue'
import Repass from '@/components/Person/Repass.vue'

export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  inject: ['reload'],
  data () {
    return {
      token: localStorage.getItem('apiToken'),
      leftTabs: ['我的资料', '实名认证', '我的竞拍','我的收藏', '机构中心', '机构标的', '修改密码'],
      leftTabsNowIndex: 0,
      customerDatas: [], //个人资料数据
    }
  },
  watch: {

  },
  created () {
    // 如果id不为undefined，改变默认tab，否则为0
    if (this.$route.query.id != undefined) {
      this.leftTabsNowIndex = this.$route.query.id
    }

    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)
    // 请求个人资料数据
    this.axios.get(this.$global.apiUrl.customer, {
      params: {
        apiToken: this.token
      }
    })
      .then((response) => {
        if (response.data.error.code != 0) {
          // 清除过期token
          localStorage.removeItem("apiToken");
          this.$confirm('登录已过期,请重新登录！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.$router.push({
              path: '/login',
            })
          }).catch(() => {
            this.$router.push({
              path: '/',
            })
          });
        } else {
          this.customerDatas = response.data.customer
          this.hasEnterprise = response.data.hasEnterprise
          if (this.hasEnterprise == true) {
            this.axios.get(this.$global.apiUrl.enterprise, {
              params: {
                apiToken: this.token
              }
            })
              .then((response) => {
                if (response.data.error.code == 0) {
                  this.enterprise = response.data.enterprise
                  this.hasEnterpriseStatu = response.data.enterprise.status
                }
              })
              .catch(() => { })
          }
        }
      })
      .catch(() => { })

    if (this.$route.query.act == 'jp') {
      this.toggleTabs(2, 1);
      return;
    }
  },
  mounted () {

  },
  methods: {
    // tab切换
    toggleTabs: function (index, n) {
      if (n == 1) {
        this.leftTabsNowIndex = index;
      }
      // if (index == 2) {
      //   // 请求数据
      //   this.axios.get(this.$global.apiUrl.customer_auctions, {
      //     params: {
      //       apiToken: this.token
      //     }
      //   })
      //     .then((response) => {
      //       if (response.data.error.code == 0) {
      //         this.auctions = response.data.auctions
      //       }
      //     })
      //     .catch(() => { })
      // }
      if (index == 4) {
        if (this.hasEnterprise == true) {
          this.axios.get(this.$global.apiUrl.enterprise, {
            params: {
              apiToken: this.token
            }
          })
            .then((response) => {
              if (response.data.error.code == 0) {
                this.enterprise = response.data.enterprise
                this.hasEnterpriseStatu = response.data.enterprise.status
              }
            })
            .catch(() => { })
        }
      }
    },

    // 上传图片
    // getPersonFile: function (img) {
    // 	const file = event.target.files[0]
    // 		//请求接口前需要传的参数
    // 		let formData = new FormData()
    // 		formData.append('apiToken', this.token)
    // 		formData.append('file', file)
    // 		this.axios.post(this.$global.apiUrl.upload_file, formData, {
    // 			headers: {
    // 				'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
    // 			}
    // 		})
    // 		.then((response) => {
    // 			console.log(response)
    // 			if(response.data.error.code == 0){
    // 				this.headImg = response.data.url
    // 				this.headimg = true
    // 				发送图片保存上
    // 				this.axios.post(this.$global.apiUrl.upload_file, formData, {
    // 					headers: {
    // 						'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
    // 					}
    // 				})
    // 				.then((response) => {
    // 					console.log(response)
    // 					if(response.data.error.code == 0){
    // 						this.headImg = response.data.url
    // 						this.headimg = true
    // 					}
    // 				})
    // 				.catch(() => {})
    // 			}
    // 		})
    // 		.catch(() => {})
    // },

  },
  computed: {

  },
  components: {
    Auction,
    Autonym,
    Orders,
    OrganizationBiaodi,
    OrganizationCenter,
    Repass
  }
}
</script>